import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Spin, Typography, notification } from 'antd';
import { CategoriesProxy } from '../services/catalogServiceAPI/categoriesProxy';
import { CategoryForm } from './CategoryForm';
import { CategorySchedules } from './CategorySchedules';

const { Title } = Typography;

export function EditCategory() {
    const { id } = useParams();
    const history = useHistory();
    const proxy = useMemo(() => new CategoriesProxy(), []);
    const [categories, setCategories] = useState(null);

    useEffect(() => {
        proxy.list()
            .then(setCategories)
            .catch((e) => notification.error({ message: 'Failed to load categories', description: e.message }));
    }, [proxy]);

    const save = async (values) => {
        await proxy.update(id, values);
        notification.success({ message: 'Category saved' });
        history.push('/category');
    };

    if (!categories) return <div style={{ padding: 32 }}><Spin /></div>;
    const category = categories.find((c) => c.id === id);
    if (!category) return <div style={{ padding: 32 }}>Category not found</div>;
    return (
        <div style={{ padding: 24, maxWidth: 720 }}>
            <Title level={3}>Edit Category: {category.title}</Title>
            <div style={{ maxWidth: 560 }}>
                <CategoryForm key={id} categories={categories} category={category} onSubmit={save} submitLabel="Save" />
            </div>
            <CategorySchedules key={`schedules-${id}`} categories={categories} category={category} />
        </div>
    );
}
